export default [
  {
    id: 'UNO',
    name: 'UNO',
  },
  {
    id: 'CAJA',
    name: 'CAJA',
  },
];
